import { ReactElement } from 'react';
import Table from '@/common/Table';

export type ReportTableSubHeaderColumn = {
  name?: string;
  description?: string;
  value?: string;
};

export type ReportTableSubHeaderProps = {
  columns?: Record<string, ReportTableSubHeaderColumn>;
};

const ReportTableSubHeader = ({ columns }: ReportTableSubHeaderProps): ReactElement => (
  <Table.Row className="ReportTableHeader" header>
    <Table.Cell className="ReportTableCell SELECT" />
    {columns &&
      Object.entries(columns).map(
        ([key, { name, description, value } = {}]: [string, ReportTableSubHeaderColumn]): ReactElement => (
          <Table.Cell className={`ReportTableHeaderCell ${key.toUpperCase()}`} title={description || name} key={key}>
            {value}
          </Table.Cell>
        )
      )}
  </Table.Row>
);

export default ReportTableSubHeader;
